<template>
  <div class="legal-info-page container">
    <Title class="mb30" current-name="Юридическая информация">
      Юридическая информация
    </Title>
    <ul class="legal-info-page_links">
      <li
        v-for="item in links"
        :key="item.slug"
      >
        <nuxt-link :to="`/legal-info/${item.slug}${linkQuery}`">
          {{ item.listTitle }}
        </nuxt-link>
      </li>
    </ul>
  </div>
</template>

<script>
import Title from '~/components/UI/Title.vue'

export default {
  components: { Title },
  computed: {
    linkQuery () {
      if (this.$route.query.frame) {
        return '?frame=1'
      }
      return ''
    },
  },
  async asyncData ({ $axios, store }) {
    try {
      const api = store.getters['api/getLegalInfo']
      const res = await $axios.get(api)
      return { links: res.data.items }
    } catch (e) {
      return { links: [] }
    }
  },
  head () {
    return {
      title: 'Юридическая информация | СУШИСЕТ',
    }
  },
}
</script>
